import React, { useCallback, FC, MouseEvent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Hidden from '@mui/material/Hidden'
import IconButton from '@mui/material/IconButton'

import MenuButton from '../widgets/MenuButton'
import authSelectors from '../../store/selectors/auth'
import rbacSelectors from '../../store/selectors/rbac'
import projectSelectors from '../../store/selectors/project'
import projectActions from '../../store/modules/project'
import routerActions from '../../store/modules/router'
import networkActions from '../../store/modules/network'

import MoreVert from '@mui/icons-material/MoreVert'

import {
  ThunkDispatcher,
} from '../../types/store'

import {
  MenuButtonItem,
} from '../../types/app'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  smallMenuHolder: {
    paddingRight: theme.spacing(2),
    width: '100%',
    textAlign: 'right',
  }
}));

const ProjectSelector: FC<React.PropsWithChildren<unknown>> = ({

}) => {

  const classes = useStyles()
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const user = useSelector(authSelectors.data)
  const orgs = useSelector(projectSelectors.userOrgs)
  const getOrgName = useSelector(rbacSelectors.getOrgNameFactory)
  const currentProjectId = useSelector(projectSelectors.currentProjectId)
  const currentOrgId = useSelector(projectSelectors.currentOrgId)
  
  const HiddenAny = Hidden as any

  const onChangeEvent = useCallback(async (e: any) => {
    dispatch(networkActions.setGlobalLoading({
      active: true,
      message: 'switching organisations...'
    }))
    await thunkDispatch(projectActions.setCurrentOrg({
      project: currentProjectId,
      org: e.target.value as string,
    }))
    dispatch(routerActions.navigateTo('dashboard'))
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }, [
    currentProjectId,
  ])

  const onChangeOrg = useCallback(async (menuItem: MenuButtonItem) => {
    if(!menuItem.meta || !menuItem.meta.id) return
    dispatch(networkActions.setGlobalLoading({
      active: true,
      message: 'switching organisations...'
    }))
    await thunkDispatch(projectActions.setCurrentOrg({
      project: currentProjectId,
      org: menuItem.meta.id,
    }))
    dispatch(routerActions.navigateTo('dashboard'))
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }, [
    currentProjectId,
  ])

  const getButton = useCallback((onClick: (e: MouseEvent) => void) => {
    return (
      <IconButton onClick={ onClick } size="large">
        <MoreVert color="primary" />
      </IconButton>
    );
  }, [])

  const getItems = useCallback(() => {
    return orgs.map<MenuButtonItem>((org, i) => {
      const result: MenuButtonItem = {
        title: getOrgName(org.id),
        meta: {
          id: org.id,
        },
      }
      return result
    })
  }, [
    getOrgName,
    orgs,
  ])

  if(!user || !currentProjectId || !currentOrgId || orgs.length <= 1) return null

  return (
    <>
      
      <HiddenAny smUp>
        <div className={ classes.smallMenuHolder }>
          <MenuButton
            getButton={ getButton }
            getItems={ getItems }
            onClick={ onChangeOrg }
          />
        </div>
      </HiddenAny>

      <HiddenAny xsDown>
        <Select
          variant="standard"
          value={ currentOrgId }
          onChange={ onChangeEvent }
          MenuProps={{
            PaperProps: {
              style: {
                border: '1px solid #d3d4d5',
              },
            },
          }}
        >
          {
            orgs.map((org, i) => (
              <MenuItem
                key={ org.id }
                value={ org.id }
              >
                { getOrgName(org.id) }
              </MenuItem>
            ))
          }
        </Select>
      </HiddenAny>
    </>
  )
}

export default ProjectSelector